import { fetchWarehouseList } from '#/api/system/warehouse/fetchList';
import { fetchWarehouseDetail } from '#/api/system/warehouse/fetchDetail';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

export function mapWarehouseRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: row.code ? `${row.code} - ${row.name}` : row.name,
  }));
}

export async function fetchWarehouseSelectOptions() {
  const { data } = await fetchWarehouseList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: {},
  });

  return mapWarehouseRowsToSelectOptions(data);
}

export async function searchWarehouseFilterOptions({ keyword }) {
  const result = await fetchWarehouseList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    filters: {},
    sort: [],
  });

  return mapWarehouseRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 warehouseId 但 label cache 空時，依 id 補 `code - name`。
 * @returns {Promise<boolean>} 是否有寫入新 label（供觸發 re-render）
 */
export async function hydrateWarehouseFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchWarehouseDetail(id);
      const row = result?.data;
      if (!row) {
        return;
      }

      const label = row.code ? `${row.code} - ${row.name}` : (row.name || String(id));
      labelCache.set(String(id), label);
    } catch {
      // 留下 unresolved；ListFilterStatus 會顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}
